import { render, staticRenderFns } from "./order-model.vue?vue&type=template&id=596f43a0&scoped=true&"
import script from "./order-model.vue?vue&type=script&lang=js&"
export * from "./order-model.vue?vue&type=script&lang=js&"
import style0 from "./order-model.vue?vue&type=style&index=0&id=596f43a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596f43a0",
  null
  
)

export default component.exports